import { Component, Directive, ElementRef, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { ImageService } from "src/app/services/imagen.service";

interface Image {
  id: number;
  webformatURL: string;
  likes: number;
  imageHeight: number;
  imageSize: number;
  imageWidth: number;
  largeImageURL: string;
  pageURL: string;
  previewHeight: number;
  previewURL: string;
  views: number;
}

@Component({
  selector: "app-list-image",
  templateUrl: "./list-image.component.html",
  styleUrls: ["./list-image.component.scss"],
})
export class ListImageComponent implements OnInit {
  searchTerm: string = "";
  subscription: Subscription;
  listImages: Image[] = [];
  isLoading: boolean = false;
  imagePerPage = 10;
  currentPage = 1;
  totalPages = 0;

  constructor(private _imageService: ImageService) {
    this.subscription = _imageService.getTermSearch().subscribe((term) => {
      this.currentPage = 1;
      this.isLoading = true;
      this.searchTerm = term;
      this.getImagesApi();
    });
  }

  ngOnInit() {}

  getImagesApi() {
    if (!this.searchTerm.length) {
      this._imageService.setError("Agrega un texto de busqueda");
      return;
    }
    this._imageService
      .getImagesApi(this.searchTerm, this.currentPage)
      .subscribe(
        (data) => {
          this.isLoading = false;
          const { hits, totalHits } = data;

          if (hits.length === 0) {
            this._imageService.setError("No se encontraron resultados");
            return;
          }

          this.totalPages = Math.ceil(totalHits / this.imagePerPage);
          this.listImages = hits;
        },
        (error) => {
          this._imageService.setError("Error de conexión: " + error.statusText);
          this.isLoading = false;
        }
      );
  }

  pagePrevious() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.isLoading = true;
      this.listImages = [];
      this.getImagesApi();
    }
  }

  pageNext() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.isLoading = true;
      this.listImages = [];
      this.getImagesApi();
    }
  }

  showPagination(type) {
    const typesPages = {
      previous: this.currentPage > 1,
      next: this.currentPage < this.totalPages,
    };
    return typesPages[type];
  }
}
